"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));

/**
 *
 * Tesseract Worker adapter for browser
 *
 * @fileoverview Tesseract Worker adapter for browser
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */
var check = require('check-types');

var resolveURL = require('resolve-url');

var axios = require('axios');

var b64toU8Array = require('./b64toU8Array');

var _require = require('../common/options'),
    defaultOptions = _require.defaultOptions;

var _require2 = require('../../package.json'),
    version = _require2.version;
/**
 * readFromBlobOrFile
 *
 * @name readFromBlobOrFile
 * @function
 * @access private
 * @param {object} blob A blob or file objec to read
 * @param {function} res callback function after reading completes
 */


var readFromBlobOrFile = function readFromBlobOrFile(blob, res) {
  var fileReader = new FileReader();

  fileReader.onload = function () {
    res(fileReader.result);
  };

  fileReader.readAsArrayBuffer(blob);
};
/**
 * loadImage
 *
 * @name loadImage
 * @function load image from different source
 * @access private
 * @param {string, object} image - image source, supported formats:
 *   string: URL string, can be relative path
 *   string: base64 image
 *   img HTMLElement: extract image source from src attribute
 *   video HTMLElement: extract image source from poster attribute
 *   canvas HTMLElement: extract image data by converting to Blob
 *   File instance: data from <input type="file" />
 * @returns {array} binary image in array format
 */


var loadImage = function loadImage(image) {
  if (check.string(image)) {
    // Base64 Image
    if (/data:image\/([a-zA-Z]*);base64,([^"]*)/.test(image)) {
      return Promise.resolve(b64toU8Array(image.split(',')[1]));
    } // Image URL


    return axios.get(resolveURL(image), {
      responseType: 'arraybuffer'
    }).then(function (resp) {
      return resp.data;
    });
  }

  if (check.instance(image, HTMLElement)) {
    if (image.tagName === 'IMG') {
      return loadImage(image.src);
    }

    if (image.tagName === 'VIDEO') {
      return loadImage(image.poster);
    }

    if (image.tagName === 'CANVAS') {
      return new Promise(function (res) {
        image.toBlob(function (blob) {
          readFromBlobOrFile(blob, res);
        });
      });
    }
  }

  if (check.instance(image, File) || check.instance(image, Blob)) {
    return new Promise(function (res) {
      readFromBlobOrFile(image, res);
    });
  }

  return Promise.reject();
};

var downloadFile = function downloadFile(path, blob) {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, path);
  } else {
    var link = document.createElement('a'); // Browsers that support HTML5 download attribute

    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', path);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
/*
 * Default options for browser worker
 */


exports.defaultOptions = (0, _extends2.default)({}, defaultOptions, {
  workerPath: typeof process !== 'undefined' && process.env.TESS_ENV === 'development' ? resolveURL("/dist/worker.dev.js?nocache=" + Math.random().toString(36).slice(3)) : "https://unpkg.com/tesseract.js@v" + version + "/dist/worker.min.js",

  /*
   * If browser doesn't support WebAssembly,
   * load ASM version instead
   */
  corePath: "https://unpkg.com/tesseract.js-core@v2.0.0-beta.10/tesseract-core." + (typeof WebAssembly === 'object' ? 'wasm' : 'asm') + ".js"
});
/**
 * spawnWorker
 *
 * @name spawnWorker
 * @function create a new Worker in browser
 * @access public
 * @param {object} instance - TesseractWorker instance
 * @param {object} options
 * @param {string} options.workerPath - worker script path
 * @param {boolean} options.workerBlobURL - Use a blob:// URL for the worker script
 */

exports.spawnWorker = function (instance, _ref) {
  var workerPath = _ref.workerPath,
      workerBlobURL = _ref.workerBlobURL;
  var worker;

  if (Blob && URL && workerBlobURL) {
    var blob = new Blob(["importScripts(\"" + workerPath + "\");"], {
      type: 'application/javascript'
    });
    worker = new Worker(URL.createObjectURL(blob));
  } else {
    worker = new Worker(workerPath);
  }

  worker.onmessage = function (_ref2) {
    var data = _ref2.data;

    if (data.jobId.startsWith('Job')) {
      instance.recv(data);
    } else if (data.jobId.startsWith('Download')) {
      var path = data.path,
          d = data.data,
          type = data.type;

      var _blob = new Blob([d], {
        type: type
      });

      downloadFile(path, _blob);
    }
  };

  return worker;
};
/**
 * terminateWorker
 *
 * @name terminateWorker
 * @function terminate worker
 * @access public
 * @param {object} instance TesseractWorker instance
 */


exports.terminateWorker = function (instance) {
  instance.worker.terminate();
};
/**
 * sendPacket
 *
 * @name sendPacket
 * @function send packet to worker and create a job
 * @access public
 * @param {object} instance TesseractWorker instance
 * @param {object} iPacket data for worker
 */


exports.sendPacket = function (instance, iPacket) {
  var packet = (0, _extends2.default)({}, iPacket);
  loadImage(packet.payload.image).then(function (buf) {
    return new Uint8Array(buf);
  }).then(function (img) {
    packet.payload.image = Array.from(img);
    instance.worker.postMessage(packet);
  });
};